/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	(function () {
	    // 依赖引入 
	    var Util = __webpack_require__(1); // 多种工具
	    var Generate = __webpack_require__(2); // 用于生成html代码 
	
	
	    // 全局变量
	    var agt = Util.getSearch().agt || 0; // 渠道
	    var agt_link = agt ? '?agt=' + agt : '';
	    var $content = $("#content");
	    var $article = $("#article");
	
	    // 全局配置
	    // 1.内容区去掉阅读全文，增加翻页; 4 搜狗, 8 百度新闻,10 好123,35 鲜果渠道
	    var global_pages = agt == 8 || agt == 10;
	    // 2.右侧内容区底部固定
	    var global_fixed = agt == 8 || agt == 10;
	    // 3.娱乐+都市模块是否展示
	    var global_hots = agt == 8 || agt == 35;
	
	    var App = {
	
	        id: window.global.id, // 文章id 
	        type: window.global.type, // 文章类型  
	        category: encodeURI(window.global.category), // 频道id
	        searchKey: window.global.searchKey, //搜索关键字 
	
	        aPage: window.global.aPage, // A页
	        mediaPage: window.global.mediaPage, // ta页 
	        tagPage: window.global.tagPage, // tag页
	        isPure: window.global.isPure, // 判断是否是纯文章A页 0显示 1不显示 
	
	        newsOffsetTop: 0,
	        sideBarHeight: 0,
	        // 接口地址定义
	        api: {
	            recomMenu: '/api/tag?', // 推荐菜单
	            recomFeed: '/api/feed?', // 推荐阅读
	            recomTagFeed: '/api/tag_feed?', // tag 页推荐阅读
	            recomMediaFeed: '/api/m/', // ta 页推荐阅读
	            hot: '/api/hot?', // 热门推荐
	            hots: '/api/hots?' // 热门推荐 
	        },
	
	        ajax: function ajax(url, callback) {
	            $.ajax({
	                type: 'GET',
	                url: url + '&' + 'agt=' + agt,
	                dataType: 'jsonp',
	                jsonp: 'callback',
	                success: function success(result) {
	                    if (result.code == 200) {
	                        if (result.data != '' && result.data != undefined) {
	                            callback && callback(result.data);
	                        } else {
	                            $("#newsLoading").html("暂无数据");
	                        }
	                    } else {
	                        $("#newsLoading").remove();
	                    }
	                }
	            });
	        },
	
	        article: {
	            init: function init() {
	                this.video();
	                this.uninterestedBoxEvent();
	
	                // 非领导人模板
	                if (!App.isPure) {
	                    // global_pages 配置项
	                    if (!global_pages) {
	                        this.more();
	                    }
	                }
	            },
	            video: function video() {
	                var newDiv = document.getElementById("article");
	                var videos = [].slice.call(newDiv.querySelectorAll('video'));
	                videos.map(function (video, index) {
	                    if (video.dataset.source) {
	                        //平台内视频
	                        video.src = video.dataset.source;
	                        video.setAttribute("controls", "controls");
	                        if (video.dataset.desc) {
	                            video.insertAdjacentHTML('afterend', '<p class="video-description">' + video.dataset.desc + '</p>');
	                        }
	                    } else {
	                        //外域视频
	                        if (video.dataset.src) {
	                            var vvv = decodeURIComponent(video.dataset.src);
	                            $.ajax({
	                                type: 'GET',
	                                url: '/api/video?url=' + encodeURIComponent(vvv),
	                                beforeSend: function beforeSend(request) {
	                                    request.setRequestHeader("Accept", 'application/vnd.hq_time.v1+jsonP');
	                                    request.setRequestHeader("ClientVersion", 'v1.13');
	                                },
	                                processData: false,
	                                success: function success(msg) {
	
	                                    if (msg.status != 'fail') {
	                                        video.insertAdjacentHTML('beforebegin', '<div class="frame-wrapper">' + decodeURIComponent(msg) + '</div>'); //播放代码,iframe嵌套的播放器
	
	                                        if (video.dataset.desc && video.dataset.desc != undefined) {
	                                            video.insertAdjacentHTML('afterend', '<p class="video-description">' + video.dataset.desc + '</p>'); //描述信息
	                                        }
	                                        video.parentNode.removeChild(video);
	                                    } else {
	                                        video.insertAdjacentHTML('beforebegin', '<div class="frame-wrapper">' + decodeURIComponent(msg.data) + '</div>'); //播放代码,iframe嵌套的播放器
	                                    }
	                                },
	                                error: function error(msg) {
	                                    // console.error(msg);
	                                }
	                            });
	                        }
	                    }
	                });
	            },
	            more: function more() {
	                var $articleCon = $article.find(".a-con");
	                if ($articleCon.height() >= 700) {
	                    $articleCon.css('height', 700);
	
	                    var moreHTML = '<a href="javascript:void(0);" id="more">\u9605\u8BFB\u5168\u6587<i class="iconfont icon-xiangxia-copy"></i></a>';
	                    $articleCon.append(moreHTML);
	
	                    $("#more").on("click", function () {
	                        $articleCon.css({ 'height': 'auto' });
	                        $(this).remove();
	
	                        App.newsOffsetTop = $content.find("#news").offset().top;
	                    });
	                }
	            },
	            uninterestedBoxEvent: function uninterestedBoxEvent() {
	
	                var $uninterested = $("#uninterested");
	                var $uninterestedBox = $(".uninterested-box");
	                var $other = $uninterested.find('li[data-val=10]');
	
	                $uninterested.find('a').on("click", function () {
	
	                    var isClick = $(this).attr('data-click');
	
	                    if (isClick == "1") {
	                        $(this).attr('data-click', 0);
	                        $uninterestedBox.hide();
	                    } else {
	                        $(this).attr('data-click', 1);
	                        $uninterestedBox.show();
	                    }
	                });
	
	                $uninterestedBox.find("li").on("click", function () {
	
	                    var isSelected = $(this).attr("class");
	                    if (isSelected) {
	                        $(this).removeClass('selected');
	                        // 其他问题
	                        $(this).attr('data-val') == '10' ? $uninterestedBox.find(".otherarea").hide() : '';
	                    } else {
	                        $uninterested.find('.info').hide();
	                        $(this).addClass('selected');
	                        // 其他问题
	                        $(this).attr('data-val') == '10' ? $uninterestedBox.find(".otherarea").show() : '';
	                    }
	                });
	
	                $uninterestedBox.find(".btn").on("click", function () {
	
	                    if (!$uninterested.find('.selected').length || $other.attr("class") == "selected" && $uninterestedBox.find(".otherarea").val() == '') {
	                        $uninterested.find('.info').show();
	                        return false;
	                    }
	
	                    var $unfeedback = $uninterested.find('.unfeedback');
	
	                    $uninterested.find('a').attr('data-click', 0);
	                    $uninterestedBox.hide();
	
	                    $unfeedback.show();
	                    setTimeout(function () {
	                        $unfeedback.hide();
	                    }, 3000);
	                });
	            }
	        },
	
	        sideBar: {
	            init: function init() {
	                App.sideBar.search();
	                App.sideBar.hot();
	
	                if (global_hots) {
	                    App.sideBar.hots();
	                }
	            },
	            search: function search() {
	
	                var $search = $("#search");
	                var str = '\n                <input type="text" class="s-txt" placeholder="\u5927\u5BB6\u90FD\u5728\u8BF4\uFF1A' + App.searchKey + '">\n                <a href="javascript:void(0)" target="_blank" class="s-btn"><i class="iconfont icon-sousuo"></i></a>\'\n                ';
	                $search.html(str);
	                $search.find(".s-btn").on("click", function () {
	                    var sv = $search.find(".s-txt").val() || App.searchKey;
	                    window.open('https://www.baidu.com/s?wd=site:www.huanqiu.com' + sv);
	                });
	            },
	            hot: function hot() {
	                var $sideBar = $("#sideBar");
	                App.ajax(App.api.hot, function (data) {
	                    var news = data.news;
	                    var picture = data.picture;
	                    var recommend = data.recommend;
	
	                    // 需要在数据列表中插入广告，单独一条返回
	                    for (var n in picture) {
	                        if (n < 1) {
	                            $sideBar.find("#hotPics ul").prepend(Generate.hotPictureHtml(picture[n], 'large'));
	                        } else if (n < 3) {
	                            $sideBar.find("#hotPics ul").append(Generate.hotPictureHtml(picture[n]));
	                        }
	                    }
	                    Util.setImgUrl($("#hotPics"));
	                    $sideBar.find("#hotNews").html(Generate.hotHtml(news));
	                    Util.setImgUrl($("#hotNews"));
	                    $sideBar.find("#hotLists").html(Generate.hotRecommendHtml(recommend));
	                    Util.setImgUrl($("#hotLists"));
	                });
	            },
	            hots: function hots() {
	                var $sideBar = $("#sideBar");
	                App.ajax(App.api.hots, function (data) {
	                    var city = data.dushi;
	                    var ent = data.yule;
	
	                    $sideBar.find("#hotsCity").html(Generate.hotsCityHtml(city));
	                    Util.setImgUrl($("#hotsCity"));
	                    $sideBar.find("#hotsEnt").html(Generate.hotsEntHtml(ent));
	                    Util.setImgUrl($("#hotsEnt"));
	                });
	            }
	        },
	
	        recommend: {
	            init: function init() {
	                function html(callback) {
	                    var str = '<div class="content-c" id="newsWraper">';
	                    if (App.aPage) {
	                        str += '  \n                        <h2 class="title"><strong>\u63A8\u8350\u9605\u8BFB</strong></h2>\n                        <div class="c-menu" id="newsMenu"></div>';
	                    } else if (App.tagPage) {
	                        str += '<div class="c-menu c-menu-fixed" id="newsMenu"></div>';
	                    } else if (App.mediaPage) {
	                        str += '  \n                        <h2 class="title"><strong>\u5168\u90E8\u6587\u7AE0</strong></h2>';
	                    }
	                    str += '\n                      <div class="bd">\n                        <div class="news-wrapper" id="news"></div>\n                        <div id="newsLoading"><i class="iconfont icon-loading1"></i> \u52A0\u8F7D\u66F4\u591A.. </div>\n                      </div>\n                    </div>';
	                    return str;
	                }
	
	                $content.append(html());
	                App.newsOffsetTop = $content.find("#news").offset().top;
	
	                this.menu();
	                this.news();
	            },
	            menu: function menu() {
	                var $newsMenu = $content.find("#newsMenu");
	
	                App.ajax(App.api.recomMenu, function (data) {
	                    var tags = data.tags;
	                    var str = '<ul>';
	                    var selected = '';
	                    str += App.aPage ? '<li class="selected"><a href="#newsWraper">\u63A8\u8350</a></li>' : '';
	                    for (var i = 0; i < tags.length; i++) {
	                        selected = window.global.id == tags[i].code ? 'class="selected"' : '';
	                        str += ' <li ' + selected + '><a href="/tag/' + tags[i].code + agt_link + '" target="_blank">' + tags[i].name + '</a></li>';
	                    }
	                    str += '</ul>';
	
	                    $newsMenu.html(str);
	                    // $newsMenu.find("li").on("click", function() {
	                    //     $(this).addClass('selected').siblings().removeClass('selected');
	                    // });
	                });
	            },
	            news: function news() {
	                App.recommend.tmp.loading = true;
	                var $news = $content.find("#news");
	                var url = '';
	                if (App.aPage) {
	                    url = App.recommend.url + 'category=' + App.category + '&page=' + App.recommend.tmp.page;
	                } else if (App.tagPage) {
	                    url = App.recommend.url + 'code=' + App.id + '&page=' + App.recommend.tmp.page;
	                } else if (App.mediaPage) {
	                    url = App.recommend.url + App.id + '?page=' + App.recommend.tmp.page;
	                }
	
	                App.ajax(url, function (result) {
	                    var data = result;
	                    for (var n in data) {
	                        if (data[n].ad) {
	                            if (App.recommend.tmp.ad.length < 20) {
	                                // 手动控制加载小于20条广告 
	                                $news.append('<div class="aa-item"></div>');
	                                App.recommend.tmp.ad.push(data[n]);
	                            }
	                        } else {
	                            $news.append(Generate.newsHtml(data[n]));
	                            Util.setImgUrl($news);
	                        }
	                    }
	
	                    // 广告
	                    App.recommend.ad();
	
	                    App.recommend.tmp.loading = false;
	                    App.recommend.tmp.page++;
	                });
	            },
	            tmp: {
	                'ad': [],
	                'ad_count': 0,
	                'ad_count_feed': 0,
	                'ad_count_peng': 0,
	                'page': 1,
	                'loading': false
	            },
	            ad: function ad() {
	
	                var ad = App.recommend.tmp.ad,
	                    num = 0;
	                var container = document.querySelector("div#news");
	                setInterval(function () {
	                    if (num > 50) return false;
	                    var ads = container.querySelectorAll(".aa-item");
	
	                    for (var i = 0; i < ads.length; i++) {
	
	                        var adEle = ads[i];
	
	                        if (adEle.querySelector("iframe") || adEle.querySelector("div")) continue;
	                        if (adEle.childElementCount) break;
	
	                        // 仙果渠道合作方投放广告只调用对方方法
	                        if (agt == 35 && App.aPage) {
	                            num = App.recommend.tmp.ad_count++;
	                            $(adEle).attr('id', 'aa_feed_' + ad[i]._id + '_' + num);
	                            window._m0Ew4KQB_.f();
	                            break;
	                        }
	                        // feed 360 广告
	                        else if (ad[i].code.indexOf('feed') >= 0 || ad[i]._id.indexOf('feed') >= 0) {
	                                num = App.recommend.tmp.ad_count_feed++;
	                                $(adEle).attr('id', 'aa_feed_' + ad[i]._id + '_' + num).append(ad[i].code);
	                            }
	                            // 百度 广告
	                            else if (ad[i]._id.indexOf('u') >= 0) {
	                                    if (ad[i].repeat) {
	                                        num = App.recommend.tmp.ad_count++;
	                                    } else {
	                                        num = 0;
	                                    }
	                                    $(adEle).attr('id', 'BAIDU_SSP__wrapper_' + ad[i]._id + '_' + num).append(ad[i].code);
	                                }
	                                // 鹏泰广告
	                                else {
	                                        if (ad[i].repeat) {
	                                            num = App.recommend.tmp.ad_count_peng++;
	                                        } else {
	                                            num = 0;
	                                        }
	                                        $(adEle).attr('id', 'AD_SURVEY_POSITION_SIMPLE_' + ad[i]._id + '_' + num).append('<script type="text/javascript">window.AD_SURVEY_Add_AdPos_Simple && AD_SURVEY_Add_AdPos_Simple("' + ad[i]._id + '");</script>');
	                                    }
	                        break;
	                    }
	                }, 400);
	            }
	        },
	        scroll: function scroll() {
	            var docHeight = $(document).height(); //页面高度
	            var winHeight = $(window).height(); //窗口可视高度
	            var winScrollTop = $(window).scrollTop(); //滚动高度   
	
	            if (App.aPage) {
	                // 推荐阅读滚动&固定
	                App.newsOffsetTop - winScrollTop <= 100 ? $("#newsMenu").addClass('c-menu-fixed') : $("#newsMenu").removeClass('c-menu-fixed');
	                App.newsOffsetTop - winScrollTop <= 600 ? $article.find('.m-column').removeClass('column-fixed') : $article.find('.m-column').addClass('column-fixed');
	            }
	            //
	            if (!App.isPure) {
	
	                App.sideBarHeight = Math.max(App.sideBarHeight, $('#sideBar').outerHeight());
	
	                // // 右侧内容底部固定
	                if (global_fixed) {
	                    if (App.sideBarHeight - winScrollTop - winHeight + 70 <= 0) {
	
	                        $('#sideBar').find(".side-bar-con").css({ "position": "fixed", "bottom": 0 });
	                    } else {
	                        $('#sideBar').find(".side-bar-con").removeAttr('style');
	                    }
	                }
	                // 默认右侧热点新闻(.s-b)固定
	                else {
	                        if (App.sideBarHeight - winScrollTop <= 0) {
	                            $('#sideBar').find(".s-b").addClass('s-fixed');
	                        } else {
	                            $('#sideBar').find(".s-b").removeClass('s-fixed');
	                        }
	                    }
	
	                // 推荐阅读加载
	                if (docHeight - winHeight - winScrollTop <= 2000) {
	                    if (!App.recommend.tmp.loading) {
	                        if (App.recommend.tmp.page <= 25) {
	                            App.recommend.news();
	                        } else {
	                            $("#newsLoading").html("没有内容了~");
	                        }
	                    }
	                }
	            }
	        },
	        init: function init() {
	
	            var load = false;
	
	            // 详情页
	            if (this.aPage) {
	                this.article.init();
	                this.sideBar.init();
	                this.recommend.url = App.api.recomFeed;
	                this.recommend.init();
	
	                load = true;
	            }
	
	            // tag 页
	            if (this.tagPage) {
	                this.sideBar.init();
	                this.recommend.url = App.api.recomTagFeed;
	                this.recommend.init();
	
	                load = true;
	            }
	
	            // media 页
	            if (this.mediaPage) {
	                this.sideBar.init();
	                this.recommend.url = App.api.recomMediaFeed;
	                this.recommend.init();
	
	                load = true;
	            }
	
	            load && $(window).on("scroll", function () {
	                App.scroll();
	            });
	        }
	    };
	    App.init();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	var Util = {
	  // return 标题截断
	  generateTitle: function generateTitle(title) {
	    var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
	
	    var count = 0;
	    if (!title || typeof title.length !== 'number') {
	      return title;
	    }
	    for (var i = 0, len = title.length; i < len; i++) {
	      // 是否是半角
	      count += /[\u0000-\u00FF]/.test(title[i]) ? 0.5 : 1;
	      if (count >= num) {
	        return title.substr(0, i) + '…';
	      }
	    }
	    return title;
	  },
	  // return 时间显示格式
	  generateTime: function generateTime(date) {
	    var currDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : +new Date();
	
	    if (typeof date === 'string') {
	      date = +new Date(date.replace(/-/g, '/'));
	    }
	    if (isNaN(date)) {
	      return '';
	    }
	    var diffDate = currDate - date;
	    // 一分钟内
	    if (diffDate <= 60000) {
	      return '刚刚';
	    } else if (diffDate <= 3600000) {
	      return ~~(diffDate / 60000) + '分钟前';
	    } else if (diffDate <= 86400000) {
	      return ~~(diffDate / 3600000) + '小时前';
	    } else if (diffDate <= 604800000) {
	      return ~~(diffDate / 86400000) + '天前';
	    }
	    return new Date(date).getMonth() + 1 + '月' + new Date(date).getDate() + '日';
	  },
	  // return search对象
	  getSearch: function getSearch() {
	    var searchObject = {};
	    var searchArr = location.search.substr(1).split('&');
	    searchArr.forEach(function (item, index) {
	      var _item$split = item.split('='),
	          name = _item$split[0],
	          value = _item$split[1];
	
	      if (name.length) {
	        searchObject[name] = value;
	      }
	    });
	    return searchObject;
	  },
	  // return search对象
	  getSearchByString: function getSearchByString(urlStr) {
	    if (urlStr.indexOf('?') < 0) {
	      return {};
	    }
	    var searchObject = {};
	    var searchArr = urlStr.split('?')[1].split('&');
	    searchArr.forEach(function (item, index) {
	      var _item$split2 = item.split('='),
	          name = _item$split2[0],
	          value = _item$split2[1];
	
	      if (name.length) {
	        searchObject[name] = value;
	      }
	    });
	    return searchObject;
	  },
	  // return hash对象
	  getHash: function getHash() {
	    var hashObject = {};
	    var hashArr = location.hash.substr(1).split('&') || location.hash.substr(1).split('?');
	
	    console.log();
	    hashArr.forEach(function (item, index) {
	      var _item$split3 = item.split('='),
	          name = _item$split3[0],
	          value = _item$split3[1];
	
	      if (name.length) {
	        hashObject[name] = value;
	      }
	    });
	    return hashObject;
	  },
	  // 设置cookie
	  setCookie: function setCookie(key, value, expiredays) {
	    var exdate = new Date();
	    exdate.setDate(exdate.getDate() + expiredays);
	    document.cookie = key + '=' + escape(value) + (expiredays == null ? '' : ';expires=' + exdate.toGMTString());
	  },
	  // 得到cookie
	  getCookie: function getCookie(key) {
	    if (document.cookie.length > 0) {
	      var cookieStart = document.cookie.indexOf(key + '=');
	      if (cookieStart !== -1) {
	        cookieStart = cookieStart + key.length + 1;
	        var cookieEnd = document.cookie.indexOf(';', cookieStart);
	        if (cookieEnd === -1) {
	          cookieEnd = document.cookie.length;
	        }
	        return unescape(document.cookie.substring(cookieStart, cookieEnd));
	      }
	    }
	    return '';
	  },
	  // 懒加载图片
	  setImgUrl: function setImgUrl($elem) {
	    var $imgElems = $elem.find('img');
	    $.each($imgElems, function (index, item) {
	      var $item = $(item);
	      if ($item.attr('data-src') !== undefined && $item.attr('src') !== $item.attr('data-src')) {
	        $item.attr('src', $item.attr('data-src'));
	        $item.removeAttr('data-src');
	      }
	    });
	  },
	  // return 获取当前内容距离顶部距离 
	  getOffsetTop: function getOffsetTop($elem) {
	    return $elem.offset().top;
	  }
	};
	
	module.exports = Util;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// HTML生成器
	var Util = __webpack_require__(1);
	var agt = Util.getSearch().agt; // 渠道
	var link = agt ? '?agt=' + agt : '';
	
	var Generate = {
	  // return 单个新闻HTML字符串
	  newsHtml: function newsHtml(data) {
	    var str = '';
	    var date = Util.generateTime(data.date);
	
	    if (data.images.length === '' || data.images.length === 'undefined') {
	      return;
	    }
	
	    // 无图
	    if (data.images.length === 0) {
	
	      str += '<div class="news-item">\n              <h3 class="n-title"><a href="' + data.path + link + '" target="_blank">' + data.title + '</a></h3>\n              <div class="n-tool">\n                <span class="original">' + data.source + '</span><span class="dot">\xB7</span><span class="time">' + data.published_at + '</span>\n              </div>\n            </div>\n            ';
	    }
	    // 一张图
	    else if (data.images.length && data.images.length <= 3) {
	
	        str += '<div class="news-item">\n              <div class="mixin">\n                <a href="' + data.path + link + '" target="_blank" class="m-pic"><img data-src="' + data.images[0].src + '?w=300"  alt="' + data.images[0].alt + '"></a>\n                <div class="m-txt">\n                  <h3 class="m-title"><a href="' + data.path + link + '" target="_blank">' + data.title + '</a></h3>\n                  <div class="n-tool">\n                    <span class="original">' + data.source + '</span><span class="dot">\xB7</span><span class="time">' + data.published_at + '</span>\n                  </div>\'\n                </div>\n              </div>\n            </div>\n          ';
	      }
	      // 四张图
	      else if (data.images.length >= 4) {
	
	          str += '<div class="news-item">\n            <h3 class="n-title"><a href="' + data.path + link + '" target="_blank">' + data.title + '</a></h3>\n            <div class="n-pic">\n              <a href="' + data.path + link + '" target="_blank">\n                <div class="pic-item"><img data-src="' + data.images[0].src + '?w=300" alt="' + data.images[0].alt + '"></div>\n                <div class="pic-item"><img data-src="' + data.images[1].src + '?w=300" alt="' + data.images[1].alt + '"></div>\n                <div class="pic-item"><img data-src="' + data.images[2].src + '?w=300" alt="' + data.images[2].alt + '"></div>\n                <div class="pic-item"><img data-src="' + data.images[3].src + '?w=300" alt="' + data.images[3].alt + '"></div>\n              </a>\n            </div>\n            <div class="n-tool">\n              <span class="original">' + data.source + '</span><span class="dot">\xB7</span><span class="time">' + data.published_at + '</span>\n            </div>\n          </div>\n          ';
	        }
	
	    return str;
	  },
	  // return 标题头
	  headerHtml: function headerHtml(title) {
	    var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var str = '\n        <h2 class="title">\n          <strong>' + title + '</strong>\n          ' + children + '\n        </h2>\n      ';
	    return str;
	  },
	  // 热点新闻
	  hotHtml: function hotHtml(data) {
	    var str = Generate.headerHtml('热点新闻');
	    str += '<ul class="hot_mixin_list">';
	    for (var n in data) {
	      str += '<li>';
	      if (data[n].thumb) {
	        str += '\n              <a href="' + data[n].path + link + '" class="m-img" target="_blank">\n                <img data-src="' + data[n].thumb + '?w=180">\n              </a>';
	      }
	      str += '\n              <div class="m-txt">\n                <h3 class="title"><a href="' + data[n].path + link + '" target="_blank">' + data[n].title + '</a></h3>\n                <div class="info"><a href="' + data[n].path + link + '" target="_blank"><em>' + data[n].view_count + '</em>\u9605\u8BFB</a></div>\n              </div>\n            <li>';
	    }
	    str += '</ul>';
	    return str;
	  },
	  // 热门图集--需要在数据列表中插入广告，单独一条返回
	  hotPictureHtml: function hotPictureHtml(data) {
	    var large = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var str = '';
	    if (large) {
	
	      str += '\n          <li class="big-pic">\n            <a href="' + data.path + link + '" target="_blank">\n              <div class="ppic"><img data-src="' + data.thumb + '?w=600"></div>\n              <p class="ptxt">' + data.title + '</p>\n            </a>\n          </li>\n          ';
	      return str;
	    }
	    str += '\n            <li>\n              <a href="' + data.path + link + '" target="_blank">\n                <div class="ppic"><img data-src="' + data.thumb + '?w=300"></div>\n                <p class="ptxt">' + data.title + '</p>\n              </a>\n            </li>\n            ';
	    return str;
	  },
	  // 推荐
	  hotRecommendHtml: function hotRecommendHtml(data) {
	    var str = Generate.headerHtml('推荐');
	    str += '<ul class="hot-list">';
	    for (var n in data) {
	      if (n < 3) {
	        str += '\n              <li>\n                <em class="c">0' + (parseInt(n) + 1) + '</em>\n                <a href="' + data[n].url + link + '" target="_blank">' + data[n].title + '</a>\n              </li>';
	      } else {
	        str += '\n              <li>\n                <em>0' + (parseInt(n) + 1) + '</em>\n                <a href="' + data[n].url + link + '" target="_blank">' + data[n].title + '</a>\n              </li>';
	      }
	    }
	    str += '</ul>';
	    return str;
	  },
	  // 娱乐
	  hotsEntHtml: function hotsEntHtml(data) {
	    var str = Generate.headerHtml('娱乐看点');
	    str += '<ul class="pic_list">';
	    for (var n in data) {
	      str += '\n          <li>\n            <a href="' + data[n].path + '" target="_blank">\n            <div class="ppic"><img data-src="' + data[n].thumb + '?w=300"></div>\n            <p class="ptxt">' + data[n].title + '</p>\n            </a>\n          </li>\n          ';
	    }
	    str += '</ul>';
	    return str;
	  },
	  // 都市
	  hotsCityHtml: function hotsCityHtml(data) {
	    var str = Generate.headerHtml('都市新闻');
	    var str_1 = '<ul class="pic_list">',
	        str_2 = '<ul class="txt_list">';
	
	    for (var n in data) {
	
	      if (n < 2) {
	        str_1 += '\n              <li>\n                <a href="' + data[n].path + link + '" target="_blank">\n                  <div class="ppic"><img data-src="' + data[n].thumb + '?w=300"></div>\n                  <p class="ptxt">' + data[n].title + '</p>\n                </a>\n              </li>\n            ';
	      } else {
	        str_2 += '\n              <li>\n                <a href="' + data[n].path + link + '" target="_blank">' + data[n].title + '</a>\n              </li>\n            ';
	      }
	    }
	    str_1 += '</ul>';
	    str_2 += '</ul>';
	    return str + str_1 + str_2;
	  }
	};
	
	module.exports = Generate;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js